module.exports = __webpack_public_path__ + "bundle/assets/roundedtrianglewhite.396518f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/wayfinding/assets/roundedtrianglewhite.svg
// module id = 55
// module chunks = 0